import { useQuery } from '@tanstack/react-query';
import { IMMIGRATION_DOC_DETAILS_KEY } from '../../utils/constants/queryKeys';
import { getImmigrationDocDetails } from '../services/fn-api/ImmigrationDocuments';

export const useGetImmigrationDocDetails = (
  beneId: number | undefined,
  dependentId: number | undefined,
  includeDocuments: boolean
) => {
  return useQuery({
    queryKey: [IMMIGRATION_DOC_DETAILS_KEY, beneId, dependentId, includeDocuments],
    queryFn: () => getImmigrationDocDetails(beneId, dependentId, includeDocuments),
    enabled: !!beneId || !!dependentId,
  });
};
